import { reactive, ref } from "@vue/composition-api";
import _axios from "@/axios";
import { showSnackBar } from "@/composables/snackbar";
import { handleFormErrors } from "@/composables/form-error";

const portalModels = ref([]);
export function usePortalModel() {
  const portalModelData = reactive({
    portalModel: null,
    portalModelForm: {},
    createPortalModelDialog: false,
    editPortalModelDialog: false,
    rules: {
      nameRules: [(v) => !!v || "Le nom est obligatoire"],
      urlRules: [(v) => !!v || "Le chemin est obligatoire"],
      configurationRules: [],
    },
    portalModelFormRef: null,
    isLoading: false,
  });

  function listPortalModels() {
    portalModelData.isLoading = true;
    return _axios
      .get("/list-portal-model")
      .then((response) => {
        portalModels.value = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        portalModelData.isLoading = false;
      });
  }

  function showPortalModel(id) {
    return _axios
      .get("/portal-model/" + id)
      .then((response) => {
        portalModelData.portalModel = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function createPortalModel() {
    portalModelData.isLoading = true;
    if (portalModelData.portalModelFormRef != null) {
      const isValid = portalModelData.portalModelFormRef.validate();
      if (!isValid) {
        portalModelData.isLoading = false;
        return;
      }
    }

    const form = Object.assign({}, portalModelData.portalModelForm);
    form.configuration = form.configuration
      ? JSON.parse(form.configuration)
      : {};

    return _axios
      .post("/create-portal-model", form)
      .then(() => {
        listPortalModels();
        showSnackBar();
        portalModelData.createPortalModelDialog = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          portalModelData.rules,
          portalModelData.portalModelFormRef
        );
      })
      .finally(() => {
        portalModelData.isLoading = false;
      });
  }

  function updatePortalModel(portalModel) {
    portalModelData.isLoading = true;
    if (portalModelData.portalModelFormRef != null) {
      const isValid = portalModelData.portalModelFormRef.validate();
      if (!isValid) {
        portalModelData.isLoading = false;
        return;
      }
    }

    const form = Object.assign({}, portalModelData.portalModelForm);
    form.configuration = form.configuration
      ? JSON.parse(form.configuration)
      : {};

    return _axios
      .put("/portal-model/" + portalModel.id, form)
      .then(() => {
        listPortalModels();
        showSnackBar();
        portalModelData.editPortalModelDialog = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          portalModelData.rules,
          portalModelData.portalModelFormRef
        );
      })
      .finally(() => {
        portalModelData.isLoading = false;
      });
  }

  return {
    portalModels,
    portalModelData,
    listPortalModels,
    showPortalModel,
    createPortalModel,
    updatePortalModel,
  };
}
